module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0038.05395f1b.jpg";